module.exports = __webpack_public_path__ + "static/media/fornecedores.a9533aee.jpg";